import {
  TOGGLE_CHAT,
  TOGGLE_MODAL,
  TOGGLE_MINIMIZE,
  TOGGLE_OPTIONS,
  TOGGLE_LOADING,
  INIT_CONVERSATION,
  CLOSE_CONVERSATION,
  CLOSE_CHAT,
  REAPPEAR_CHAT,
  STORE_CONFIG,
  TOGGLE_WEBSOCKET,
  TOGGLE_SPEECH_TO_TEXT,
  TOGGLE_TEXT_TO_SPEECH,
  LOADED_TEXT_TO_SPEECH_SOUND,
  COUNTER,
  TOGGLE_ATTACH_LOADING,
  TOGGLE_ATTACH_AVAILABLE,
  TOGGLE_CLIENT_INPUT,
  TOGGLE_SEND_MSG_TO_OPERATOR,
  TOGGLE_MSG_SOUND,
  TOGGLE_MODAL_CHAT,
} from "../constants/actionCreators";
import CommonHelper from "../helpers/common"

const initialState = {
  configLoaded: false,
  opened: false,
  closed: false,
  conversation: false,
  minimize: false,
  loading: false,
  websocket: false,
  options: false,
  ttsActive: false,
  msgSoundActive: true,
  sttActive: false,
  loadedTtsSound: false,
  counter: 0,
  attachLoading: false,
  attachAvailable: false,
  inputActive: true,
  isCustomerSendMessageToOperator: false,

  modal: {
    status: false,
    message: '',
    onConfirm: () => { },
    onClose: () => { },
  },
  modalChat: {
    status: false,
    message: '',
    onConfirm: () => { },
    onClose: () => { },
  },
};

export default (store, action) => {

  if (action.type === STORE_CONFIG) {
    return {
      ...store,
      configLoaded: !CommonHelper.isEmpty(action.config)
    };
  }

  if (action.type === TOGGLE_LOADING) {
    return {
      ...store,
      loading: action.loading
    };
  }

  if (action.type === COUNTER) {
    return {
      ...store,
      counter: action.counter
    };
  }

  if (action.type === TOGGLE_MODAL) {
    return {
      ...store,
      modal: {
        ...action.payload
      }
    };
  }

  if (action.type === TOGGLE_MODAL_CHAT) {
    return {
      ...store,
      modalChat: {
        ...action.payload
      }
    };
  }

  if (action.type === TOGGLE_CHAT) {
    return {
      ...store,
      opened: action.opened
    };
  }
  
  if (action.type === CLOSE_CHAT) {
    return {
      ...store,
      closed: true
    }
  }

  if (action.type === REAPPEAR_CHAT) {
    return {
      ...store,
      closed: false
    }
  }

  if (action.type === TOGGLE_OPTIONS) {
    return {
      ...store,
      options: action.toggle
    }
  }

  if (action.type === TOGGLE_WEBSOCKET) {
    return {
      ...store,
      websocket: action.toggle
    }
  }

  if (action.type === TOGGLE_MINIMIZE) {
    return {
      ...store,
      minimize: action.minimize
    };
  }

  if (action.type === TOGGLE_ATTACH_LOADING) {
    return {
      ...store,
      attachLoading: action.status
    };
  }

  if (action.type === TOGGLE_ATTACH_AVAILABLE) {
    return {
      ...store,
      attachAvailable: action.status
    };
  }

  if (action.type === TOGGLE_MSG_SOUND) {
    return {
      ...store,
      msgSoundActive: action.toggle
    }
  }

  if (action.type === TOGGLE_SPEECH_TO_TEXT) {
    return {
      ...store,
      sttActive: action.toggle
    }
  }

  if (action.type === TOGGLE_TEXT_TO_SPEECH) {
    return {
      ...store,
      ttsActive: action.toggle
    }
  }

  if (action.type === LOADED_TEXT_TO_SPEECH_SOUND) {
    return {
      ...store,
      loadedTtsSound: action.sound,
    }
  }

  if (action.type === INIT_CONVERSATION) {
    return {
      ...store,
      conversation: true,
      config: action.config,
    }
  }

  if (action.type === CLOSE_CONVERSATION) {
    return {
      ...store,
      conversation: false
    }
  }
  if (action.type === TOGGLE_CLIENT_INPUT) {
    return {
      ...store,
      inputActive: action.toggle
    }
  }

  if (action.type === TOGGLE_SEND_MSG_TO_OPERATOR) {
    return {
      ...store,
      isCustomerSendMessageToOperator: action.toggle
    };
  }

  return store || initialState;
};
